import dayjs from 'dayjs'

export function extractDob(res) {
  if (!res) return null
  if (typeof res === 'string') return res
  if (res.dob !== undefined) return res.dob
  if (res.data?.dob !== undefined) return res.data.dob
  if (Array.isArray(res.data) && res.data.length > 0 && res.data[0]?.dob !== undefined) {
    return res.data[0].dob
  }
  if (Array.isArray(res) && res.length > 0 && res[0]?.dob !== undefined) {
    return res[0].dob
  }
  return null
}

export function isDobValid(dob) {
  if (!dob || typeof dob !== 'string') return false
  const trimmed = dob.trim()
  const lower = trimmed.toLowerCase()

  if (
    !trimmed ||
    lower === 'null' ||
    lower === 'undefined' ||
    lower === 'nan' ||
    trimmed === '0000-00-00' ||
    trimmed.startsWith('0000')
  ) {
    return false
  }

  const parsed = dayjs(trimmed)
  if (!parsed.isValid()) {
    return false
  }

  // Cek range usia wajar (misal antara 10 sampai 100 tahun)
  const age = dayjs().diff(parsed, 'year')
  if (age < 10 || age > 100) {
    return false
  }

  return true
}
